<template>
  <div class="bill container h-100" style="min-width: 1500px">
    <div class="content">
      <div class="header">
        <el-form :model="searchCondition" inline class="form" label-width="" size="mini">
          <el-form-item label="审核时间" label-width="100px">
            <el-date-picker
                    style="width: 260px;"
                    v-model="searchCondition.view_check_time"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    clearable
                    @change="onSubmit"
                    @clear="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="乙方公司">
            <CompanySelect :company-id.sync="searchCondition.company_id"/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="searchCondition.customer_name" placeholder="请输入客户名称" @change="onSubmit"/>
          </el-form-item>
          <el-form-item label="发票抬头">
            <el-input v-model="searchCondition.invoice_title" placeholder="请输入发票抬头" @change="onSubmit"/>
          </el-form-item>
          <el-form-item label="税号" label-width="80px">
            <el-input v-model="searchCondition.tax_id" placeholder="请输入税号" @change="onSubmit"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="el-button--operation" size="mini"
                       style="margin-left:20px;" @click="onSubmit">查询
            </el-button>
            <el-button @click="onReset" style="margin-right:0;" size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableCon">
        <div class="tab-content">
          <div style="height: 40px;text-align: left;margin-bottom: 10px">
            <div :class="'tab-table' + (tabActive===0?' tab-table-active':'')" @click="tabClick(0)">待审核
            </div>
            <div :class="'tab-table' + (tabActive===1?' tab-table-active':'')" @click="tabClick(1)">已通过
            </div>
            <div :class="'tab-table' + (tabActive===2?' tab-table-active':'')" @click="tabClick(2)">已拒绝
            </div>
          </div>
          <div style="padding: 10px;">
            <el-table
                    class="data-table"
                    :data="billData"
                    height="500"
                    v-loading="loading"
                    element-loading-text="加载中……"
                    element-loading-spinner="el-icon-loading"
                    border
                    :row-class-name="rowClassName"
                    :expand-row-keys="expandKeys"
                    :row-key="`id`"
                    style="width: 100%">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <div class="default-table" style="width: 100%">
                    <el-table :data="props.row.orders" style="width: 60%;margin: auto" stripe border>
                      <el-table-column prop="index" label="序号" width="80" align="center">
                        <template slot-scope="scope">
                          {{ scope.$index + 1 }}
                        </template>
                      </el-table-column>
                      <el-table-column
                              prop="order_no"
                              label="订单编号"
                              mini-width="280" align="center">
                        <template slot-scope="scope">
                          <to-order-detail :order="scope.row"/>
                        </template>
                      </el-table-column>
                      <el-table-column
                              prop="invoice_money"
                              label="申请金额"
                              mini-width="280" align="right" header-align="center">
                      </el-table-column>
                      <el-table-column
                              prop="payment_account"
                              label="订单金额" mini-width="280" align="right" header-align="center">
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="index" label="序号" width="80" align="center"/>
              <el-table-column prop="applicant" label="申请人" width="120" align="center"/>
              <el-table-column prop="company_name" label="乙方名称" width="120" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.company ? row.company.name : '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="customer_name" label="客户名称" width="220"
                               :show-overflow-tooltip="true" align="center"/>
              <el-table-column prop="invoice_title" label="发票抬头" width="220"
                               :show-overflow-tooltip="true" align="center"/>
              <el-table-column prop="tax_id" label="税号" width="220"
                               :show-overflow-tooltip="true" align="center"/>
              <el-table-column prop="invoice_number" label="发票号码" header-align="center" align="center">
                <template slot-scope="{row}">
                  <span>{{ row.invoice_number || '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amount_money" label="发票金额" header-align="center" align="right"/>
              <el-table-column prop="check_money" label="审核金额" header-align="center" align="right"/>
              <el-table-column prop="status" label="审核状态" align="center">
                <template slot-scope="scope">
                                    <span :style="{color:statusFilterColor(scope.row.status)}">
                                        <span class="dot"
                                              :style="{background:statusFilterColor(scope.row.status)}"></span>
                                        {{ statusFilterText(scope.row.status) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="created_at" label="申请时间" align="center" width="120">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" :content="scope.row.created_at"
                              placement="top">
                    <span>{{ gFunc.parseTime(scope.row.created_at, '{y}-{m}-{d}') }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="check_time" label="审核时间" align="center">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" :content="scope.row.check_time"
                              placement="top">
                    <span>{{ scope.row.check_time ? gFunc.parseTime(scope.row.check_time, '{y}-{m}-{d}') : '-' }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="操作项" width="160" align="center">
                <template slot-scope="scope">
                  <div class="buttons d-flex-row align-items-center">
                    <el-link
                            style="margin-right:10px"
                            type="primary"
                            :underline="false"
                            v-if="scope.row.orders && scope.row.orders.length > 0"
                            @click="appendExpandKey(scope.row.id)"
                    >
                      关联订单({{ scope.row.orders ? scope.row.orders.length : 0 }})
                    </el-link>
                    <el-link @click="editBill(scope.row)"
                             style=" margin-right:10px"
                             type="primary" :underline="false">详情
                    </el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <Pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="params.page"
                    :limit.sync="params.per_page"
                    @pagination="handleQuery"
            />
          </div>
        </div>
      </div>
    </div>
    <!--    发票详情-->
    <BillDetailDialog :visible.sync="dialogTableVisible" :id="id" @closed="closeDialog"/>
  </div>
</template>

<script>
import {getMyBillList} from '@/api/bill'
import {gFunc} from "@/globalFunc";
import CompanySelect from "@/views/adOrder/components/companySelect";
import BillDetailDialog from "@/views/bill/components/BillDetailDialog";
import ToOrderDetail from "@/views/adOrder/components/ToDetail";

const statusMap = {
  'wait': {
    text: '待审核',
    color: '#FFA933'
  },
  'pass': {
    text: '已通过',
    color: '#39BA85'
  },
  'reject': {
    text: '已拒绝',
    color: '#FE5B83'
  }
}

export default {
  name: "MyApply",
  components: {BillDetailDialog, CompanySelect, ToOrderDetail},
  data() {
    return {
      statusMap,
      timeFormat: "yyyy-MM-dd HH:mm",
      tabActive: 0,
      gFunc: gFunc,
      dialogTableVisible: false,
      id: '',//current edit or operate id
      searchCondition: {
        company_id: null,
        customer_name: null,
        invoice_title: null,
        tax_id: null,
        status: null,
        applicant_id: null,
        start_time: null,
        end_time: null,
        view_check_time: [],
      },
      exportCommand: '',//导出指令
      orderStatus: {
        'wait': '待审核中',
        'pass': '审核通过',
        'reject': '审核不通过'
      },
      params: {
        page: 1,
        per_page: 15,

      },
      billData: [],
      total: 0,
      loading: false,
      dialogReject: false,
      sort: {
        order: '',
        prop: ''
      },
      editMode: false,
      expandKeys: [],//展开的行
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        'spe_invoice': '电子专票',
        'common_invoice': '电子普票',
      }
      return statusMap[status]
    },
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    }
  },
  created() {
    this.searchCondition.status = 'wait';
    this.handleQuery()
  },
  methods: {
    closeDialog() {
      this.handleQuery()
      this.dialogTableVisible = false
    },
    statusFilterText(status) {
      return statusMap[status].text
    },
    statusFilterColor(status) {
      return statusMap[status].color
    },
    onSubmit() {
      this.params.page = 1
      this.handleQuery()
    },
    onReset() {
      const status = this.searchCondition.status
      this.searchCondition = {
        company_id: null,
        customer_name: null,
        invoice_title: null,
        tax_id: null,
        status: status,
        applicant_id: null,
        view_check_time: [],
        check_time: {start_time: null, end_time: null}
      }
      this.params.page = 1
      this.handleQuery()
    },
    //查看详情
    editBill(row) {
      this.id = row.id
      this.dialogTableVisible = true
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}

      //单选字段
      let singleFields = ['company_id', 'customer_name', 'invoice_title', 'tax_id', 'status']//applicant_id
      singleFields.forEach((field) => {
        if (this.searchCondition[field] != null) {
          condition[field] = this.searchCondition[field]
        }
      })
      if (this.searchCondition.view_check_time && this.searchCondition.view_check_time.length === 2) {
        condition.start_time = this.searchCondition.view_check_time[0] || null
        condition.end_time = this.searchCondition.view_check_time[1] || null
      }


      return condition
    },
    handleQuery() {
      let searchCondition = this.handleSearchCondition()
      this.getBillList({...searchCondition, ...{page: this.params.page, per_page: this.params.per_page}, ...this.sort})
    },
    getBillList(data) {
      this.loading = true
      this.billData = []
      getMyBillList(data).then(res => {
        this.billData = res.model.data
        this.total = res.model.total
        this.loading = false
      })
    },
    tabClick(index) {
      this.tabActive = index
      this.params.page = 1
      if (index === 0) {
        this.searchCondition.status = 'wait';
      } else if (index === 1) {
        this.searchCondition.status = 'pass';
      } else {
        this.searchCondition.status = 'reject';
      }
      this.handleQuery()
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1
      if ((rowIndex % 2) === 1) {
        return 'table-row commonTable-row'
      } else {
        return 'table-row success-row'
      }
    },
    appendExpandKey(id) {
      let index = this.expandKeys.indexOf(id)
      if (index > -1)
        this.expandKeys.splice(index, 1)
      else
        this.expandKeys.push(id)
    }
  }
}
</script>

<style scoped>
.bill {
  /*margin-top: 70px;*/
}

.form {
  margin-top: 20px;
  margin-bottom: 8px;
}

.header {
  background: #fff;
  padding: 5px 30px 0 30px;
  border-bottom: 1px solid #F2F2F2;
}

.tableCon {
  background: #fff;
  padding: 22px 30px 0 30px;
}

span.dot {
  width: 4px;
  height: 4px;
  margin-right: 5px;
  background: red;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
}

.el-dropdown-menu__item:hover {
  color: #FE2D54;
  background-color: rgba(232, 198, 254, 0.16);
}

.funcbars-button {
  padding: 0 23px;
  color: rgb(254, 45, 84);
  font-size: 14px;
  border: 1px solid rgb(254, 45, 84);
  border-radius: 2px;
  cursor: pointer;
}
</style>
<style>
div.el-dialog__header {
  text-align: left;
}

.reject-dialog .el-dialog {
  width: 40%;
}

.tab-content {
  border: 1px solid #F2F2F2;
  /*height: 500px;*/
}

.tab-table {
  width: 150px;
  height: 40px;
  cursor: pointer;
  margin-right: 3px;
  background-color: rgba(242, 242, 242, 0.67);
  font-size: 15px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
  display: inline-block;
}

.tab-table-active {
  background-color: #ffffff;
}

.table-row {
  height: 30px;
}

.bill-border {
  margin-bottom: 24px;
  border: 1px solid #ebeef5;
  padding: 24px;
  position: relative;
}

.export-dropdown > span {
  /*border: 1px solid #FE2D54;*/
  color: #FE2D54;
}

.export-dropdown .el-input.is-focus .el-input__inner {
  border: 1px solid #FE2D54 !important;
}

.export-dropdown .el-input.is-focus .el-input__inner, .el-select .el-input__inner:focus, .export-select .el-input .el-input__inner:active {
  border: 1px solid #FE2D54 !important;
}

</style>

